var __TEMP__ = require('./_baseHas.js');var baseHas = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hasPath.js');var hasPath = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = has;
